import type { Explanation } from './learning.ts';

/** Map data to the pinned engine; callers cannot supply scripts, HTML, URLs or animation code. */
export function toDeckSpec(explanation: Extract<Explanation, { kind: 'deck' }>) {
  return { title: explanation.title, kicker: 'Pen · A worked explanation', fig: '', slides: explanation.steps.map(step => ({
    cap: step.caption, clear: true, put: Object.fromEntries(step.objects.map(o => {
      const base = { at: o.at, c: o.c };
      switch (o.kind) {
        case 'text': return [o.id, { ...base, text: o.text, size: 3 }];
        case 'vector': return [o.id, { ...base, vec: o.values, size: 3.5 }];
        case 'box': return [o.id, { ...base, box: o.text, size: 2.5, w: 30, h: 8 }];
        case 'bars': return [o.id, { ...base, bars: o.values, labels: o.labels, w: 40, h: 20, size: 2.5 }];
      }
    })),
  })) };
}
